import { createSelector } from '@reduxjs/toolkit';
import { LegalState } from '../types/legal.types';

interface RootState {
    legal: LegalState;
}

export const selectLegalState = (state: RootState) => state.legal;

export const selectGuardianInfo: (state: RootState) => LegalState['guardianInfo'] = createSelector(
    selectLegalState,
    (legalState) => legalState.guardianInfo
);

export const selectLegalLoading: (state: RootState) => boolean = createSelector(
    selectLegalState,
    (legalState) => legalState.loading || false
);

export const selectDuplicatedEmail: (state: RootState) => boolean = createSelector(
    selectLegalState,
    (legalState) => Boolean(legalState.duplicatedEmail)
);

export const selectLegalUpdating: (state: RootState) => boolean = createSelector(
    selectLegalState,
    (legalState) => legalState.updating || false
);
